import type React from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { BaseButton } from "shared/atoms/BaseButton";

interface Props {
  className?: string;
  text?: string;
  to?: string;
}

export const BackButton: React.FC<Props> = ({ className, text, to }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const label = text ? t("patients.go_back_button", { destination: text }) : t("buttons.go_back");

  return (
    <BaseButton
      className={className}
      variant="action"
      icon="arrow-left"
      text={label}
      onClick={() => (to ? navigate(to) : navigate(-1))}
      style={{ marginBottom: "32px" }}
    />
  );
};
